import React, { useEffect, useMemo, useState } from 'react';
import {
  StyledBrandsDiv,
  StyledBrandsFilterHeaderContainerDiv,
  StyledBrandsItemContainerDiv,
  StyledBrandsItemDiv,
} from './index.styles';
import { BrandFiltersComponentsProps } from '../../organisms/SearchResults/index.types';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { useConditionalSearchResultAlertContextSERP } from '../../hooks/lib/useConditionalSearchResultAlertContext';
import {
  quickFiltersAndAmenitiesHiddenCodes,
  SearchFacetsList,
  SearchFacetsListCodes,
  studioResCode,
  studisResCodeAriaLabel,
} from '../../organisms/SearchResults/index.constant';
import { SearchFacetsResponse, SearchStateFilterObj } from '../../organisms/SearchResults/store/store.type';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';
import clsx from 'clsx';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { enableBoostBrands } from '../../organisms/SearchResults/lib/helper';
import { useWindowSize } from '@marriott/mi-ui-library';
import { MLogoContainer } from '@marriott/mi-web-ui-kit';
import { useConditionalPageContextSERP } from '../../hooks';
import CommonUtils from '../../organisms/SearchResults/lib/CommonUtils';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const BrandsFilterComponent: React.FC<BrandFiltersComponentsProps> = ({
  allFilterPopUp,
  onItemSelect,
  clearFilterState,
  itemList,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const { searchResultAlerts } = useConditionalSearchResultAlertContextSERP();
  const [currentCheckedBrandCode, setCurrentCheckedBrandCodeObj] = useState<SearchStateFilterObj | undefined>(
    enableBoostBrands() === true ? {} : searchQueryState[SearchFacetsList.brand]
  );
  const clickTrackingLoc = 'Phoenix Search Results';
  const { width } = useWindowSize();
  const [logoContainerDimensions, setLogoContainerDimensions] = useState({ width: 120, height: 60 });
  const currentViewIsTab = CommonUtils.isTabletView();
  const currentViewIsMobile = CommonUtils.isOnlyMobileView();
  useEffect(() => {
    if (currentViewIsTab) {
      setLogoContainerDimensions({ width: 90, height: 60 });
    } else if (currentViewIsMobile) {
      setLogoContainerDimensions({ width: 80, height: 60 });
    } else {
      setLogoContainerDimensions({ width: 120, height: 60 });
    }
  }, [currentViewIsTab, currentViewIsMobile]);
  const { featureFlagLogo } = useConditionalPageContextSERP();

  const getCurrentBrandFilterArray = (): SearchFacetsResponse => {
    return itemList
      ? itemList
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.brand)[0];
  };

  const currAvailableBrands = getCurrentBrandFilterArray();
  useEffect(() => {
    if (clearFilterState === null || clearFilterState === undefined) {
      setCurrentCheckedBrandCodeObj(undefined);
    }
  }, [clearFilterState]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkedBrand = (event: any, brand: any): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13 || event.type === 'mousedown') {
      let obj: SearchStateFilterObj | undefined = { ...currentCheckedBrandCode };
      if (obj !== undefined) {
        if (brand.code in obj) {
          delete obj[brand.code];
        } else {
          obj[brand.code] = brand.code;
        }
      } else {
        obj = {};
        obj[brand.code] = brand.code;
      }
      setCurrentCheckedBrandCodeObj(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.brand, obj);
      }
      setInteractionsSelected({ ...interactionsSelected, brands: true });
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const toggleAllBrand = (event: any, data: any, type: 'select' | 'unselect' = 'select'): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const selectedBrands: SearchStateFilterObj = currentCheckedBrandCode ? { ...currentCheckedBrandCode } : {};
      const availableBrands = currAvailableBrands?.buckets?.map(brand => {
        return brand.code;
      });
      data?.forEach((brand: { brandTagId: string | number }) => {
        if (type === 'select' && availableBrands?.includes(brand.brandTagId)) {
          selectedBrands[brand.brandTagId] = brand.brandTagId;
        } else if (type === 'unselect') {
          delete selectedBrands[brand.brandTagId];
        }
      });
      setCurrentCheckedBrandCodeObj(selectedBrands);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.brand, selectedBrands);
      }
      setInteractionsSelected({ ...interactionsSelected, brands: true });
    }
  };
  useMemo(() => {
    setCurrentCheckedBrandCodeObj(searchQueryState[SearchFacetsList.brand]);
  }, [searchQueryState?.BRANDS]);

  return (
    <StyledBrandsDiv className={clsx('t-font-alt-m', 'filter-button', allFilterPopUp && ['pt-3', 'pt-lg-4'])}>
      {allFilterPopUp ? (
        <fieldset>
          <StyledBrandsFilterHeaderContainerDiv className="t-font-m color-scheme1  ">
            <legend>
              <h4
                className={
                  (width && width > BREAKPOINT_DESKTOP_1023
                    ? `t-subtitle-l`
                    : width && width > BREAKPOINT_TABLET
                    ? `t-subtitle-l`
                    : `t-subtitle-m`) + ' filter-heading'
                }
              >
                {jsonContent?.brandsLabel}
              </h4>
            </legend>
          </StyledBrandsFilterHeaderContainerDiv>
        </fieldset>
      ) : (
        ''
      )}

      <StyledBrandsItemContainerDiv className={`brand-container `}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {jsonContent?.categorizedBrandsArray?.map((brandTypeData: any, idx: number) => {
          const disabledBrandCount = brandTypeData?.brandsLabelListItems.filter(
            (brand: { disable: boolean }) => brand.disable
          ).length;
          let selectedBrandCount = 0;
          if (currentCheckedBrandCode) {
            brandTypeData?.brandsLabelListItems?.forEach((brand: { brandTagId: string; disable: boolean }) => {
              if (brand.brandTagId in currentCheckedBrandCode && !brand.disable) {
                selectedBrandCount++;
              }
            });
          }
          const isAllBrandSelected = currentCheckedBrandCode
            ? brandTypeData?.brandsLabelListItems?.length - disabledBrandCount === selectedBrandCount
            : false;
          const isAllDisabled = disabledBrandCount === brandTypeData?.brandsLabelListItems.length;
          return (
            <div className="brand-type-container" key={idx}>
              <div className="t-label-xs brand-type-header">
                <div className="t-label-xs brand-type-label">{brandTypeData?.brandsTypeLabel}</div>
                <div
                  className={
                    't-font-xs brand-type-all-selector custom_click_track' + (isAllDisabled ? ' disabled-state ' : '')
                  }
                  role="button"
                  tabIndex={isAllDisabled ? -1 : 0}
                  aria-label={
                    isAllBrandSelected
                      ? brandTypeData?.clearAllbrandsTypeLabel
                      : brandTypeData?.selectAllbrandsTypeLabel
                  }
                  onClick={(e): void =>
                    toggleAllBrand(e, brandTypeData?.brandsLabelListItems, isAllBrandSelected ? 'unselect' : 'select')
                  }
                  onKeyDown={(e): void =>
                    toggleAllBrand(e, brandTypeData?.brandsLabelListItems, isAllBrandSelected ? 'unselect' : 'select')
                  }
                  {...{
                    custom_click_track_value: `${clickTrackingLoc}| ${
                      isAllBrandSelected
                        ? brandTypeData?.clearAllbrandsTypeLabel
                        : brandTypeData?.selectAllbrandsTypeLabel
                    } (${brandTypeData?.brandsLabelListItems
                      .filter(
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (brand: any) => {
                          if (!brand.disable) {
                            return brand;
                          }
                        }
                      )
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      ?.map((brand: any) => {
                        return brand?.brandTagId;
                      })}) |internal`,
                  }}
                >
                  {isAllBrandSelected && !isAllDisabled
                    ? brandTypeData?.clearAllbrandsTypeLabel
                    : brandTypeData?.selectAllbrandsTypeLabel}
                </div>
              </div>
              <div
                className="brand-type-content"
                key={'brand_type_content_' + idx}
                role="listbox"
                aria-label={brandTypeData?.brandsTypeLabel}
              >
                {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                {brandTypeData?.brandsLabelListItems?.map((brand: any, brandIdx: number) => {
                  const brandState = currAvailableBrands?.buckets?.filter(stateBrand => {
                    //to enable disable brand with UXL layer
                    brand.disable = stateBrand.count === 0;
                    //filter if brand is available or not
                    return stateBrand.code === brand.brandTagId;
                  })[0];
                  //to check whether we can select all brand or not
                  brandState === undefined ||
                  quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '')
                    ? (brand.disable = true)
                    : (brand.disable = false);
                  return (
                    <StyledBrandsItemDiv key={idx + '_' + brandIdx + '_wrapper'} className="brands-list">
                      <div
                        {...{
                          custom_click_track_value: `${clickTrackingLoc}| Brand ${
                            brandState?.code && currentCheckedBrandCode && brandState.code in currentCheckedBrandCode
                              ? 'Deselection'
                              : 'Selection'
                          }: ${brand?.brandTagTitle} |internal`,
                        }}
                        className={clsx(
                          't-font-m',
                          'brand-logo-container',
                          'analytics-click',
                          'custom_click_track',
                          brandState === undefined || brand.disable ? 'disabled' : '',
                          brandState?.code && currentCheckedBrandCode && brandState.code in currentCheckedBrandCode
                            ? 'active'
                            : ''
                        )}
                        key={idx + '_' + brandIdx}
                        tabIndex={brand.disable ? -1 : 0}
                        aria-label={
                          brand?.brandTagId?.toUpperCase() === studioResCode
                            ? studisResCodeAriaLabel
                            : brand?.brandTagTitle
                        }
                        // eslint-disable-next-line jsx-a11y/aria-role
                        role="option"
                        aria-selected={
                          brandState?.code && currentCheckedBrandCode && brandState.code in currentCheckedBrandCode
                            ? true
                            : false
                        }
                        {...(featureFlagLogo?.experience_mcom_logo_automation && {
                          onMouseDown: (ev): void => {
                            checkedBrand(ev, brandState);
                          },
                        })}
                        {...(!featureFlagLogo?.experience_mcom_logo_automation && {
                          onClick: (ev): void => {
                            checkedBrand(ev, brandState);
                          },
                        })}
                        onKeyDown={(ev): void => {
                          ev.stopPropagation();
                          // if (brandState !== undefined && brandState?.count !== 0) {
                          checkedBrand(ev, brandState);
                          // }
                        }}
                      >
                        {featureFlagLogo?.experience_mcom_logo_automation ? (
                          <MLogoContainer
                            brand={brand.brandTagId === 'MV' ? 'MVC' : brand.brandTagId}
                            aspectRatio={'3:2'}
                            width={logoContainerDimensions?.width}
                            height={logoContainerDimensions?.height}
                            alignment={'Centered'}
                            isLink={false}
                            color={'background-aware'}
                            brandFullName={brand.brandTagTitle}
                          />
                        ) : (
                          <div
                            className={clsx(
                              'brand-logo',
                              brand?.brandTagId === 'MV'
                                ? 'portfolio-icon-mvc'
                                : `brand-logo-${brand?.brandTagId?.toUpperCase()}`,
                              brandState === undefined || brand.disable ? 'brand-logo-disabled' : ''
                            )}
                          ></div>
                        )}
                      </div>
                    </StyledBrandsItemDiv>
                  );
                })}
              </div>
            </div>
          );
        })}
      </StyledBrandsItemContainerDiv>
      {allFilterPopUp ? <hr aria-hidden className="filter-separator" /> : ''}
    </StyledBrandsDiv>
  );
};
